import { searchRegexLanguageParser } from '../parser';
import { SearchQueryTermType } from '../types';

import {
  findCursorMatch,
  isAndOperator,
  isCriterion,
  isGroupEnd,
  isGroupStart,
  isNotOperator,
  isOperator,
  isOrOperator,
} from './utils';

const NOT_OPERATOR = { type: SearchQueryTermType.OPERATOR, value: 'NOT' };
const AND_OPERATOR = { type: SearchQueryTermType.OPERATOR, value: 'AND' };
const OR_OPERATOR = { type: SearchQueryTermType.OPERATOR, value: 'OR' };

export const getNextAllowedOperators = (rawQuery: string, cursorPosition: number) => {
  const { query } = searchRegexLanguageParser.parse(rawQuery);
  const cursorMatch = findCursorMatch(query, cursorPosition, rawQuery);

  if (!cursorMatch) {
    if (query.length === 0) {
      return [NOT_OPERATOR];
    }

    return [AND_OPERATOR, OR_OPERATOR];
  }

  const { index, term } = cursorMatch;

  const isAtTermStart = term.startPosition === cursorPosition;
  const isAtTermEnd = term.endPosition === cursorPosition;
  const nextTerm = query[index + 1];

  const isInsideCriterion =
    isCriterion(cursorMatch.term) &&
    cursorPosition >= cursorMatch.term.startPosition &&
    cursorPosition < cursorMatch.term.endPosition;

  if (isInsideCriterion) {
    return [NOT_OPERATOR];
  }

  if (isNotOperator(term)) {
    return [];
  }

  if (isAndOperator(term) || isOrOperator(term)) {
    return [NOT_OPERATOR];
  }

  if (isCriterion(term)) {
    if (isOperator(nextTerm)) {
      return [NOT_OPERATOR];
    }

    return [AND_OPERATOR, OR_OPERATOR, NOT_OPERATOR];
  }

  if (isGroupStart(term)) {
    if (isAtTermStart) {
      return [NOT_OPERATOR];
    }

    return [];
  }

  if (isGroupEnd(term)) {
    if (!isAtTermEnd) {
      return [];
    }

    if (isOperator(nextTerm)) {
      return [];
    }

    return [AND_OPERATOR, OR_OPERATOR];
  }

  return [NOT_OPERATOR];
};
